export default __webpack_public_path__ + "static/media/ic-chat.5dc9b4aa.svg";